// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrBox--QdXNY {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 0;
}
.src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrHeader--YEoZh {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}
.src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrTitle--tYxbC {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  color: rgba(0, 0, 0, 0.55);
}
.src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__required--R_Y6y {
  color: #e9033a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__error--KHMu4 {
  margin-top: 4px;
  color: #c20034;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
/*# sourceMappingURL=MfAttrEditor.module.css.map */`, "",{"version":3,"sources":["webpack://./MfAttrEditor.module.less","webpack://./src/components/MForm/components/MfAttrEditor/MfAttrEditor.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;ACCF;ADCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ACCF;ADEA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;ACDF;ADIA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;ADKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACHF;AACA,kDAAkD","sourcesContent":[".attrBox {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px 0;\n}\n.attrHeader {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.attrTitle {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 160%;\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.required {\n  color: #e9033a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n\n.error {\n  margin-top: 4px;\n  color: #c20034;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n",".attrBox {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px 0;\n}\n.attrHeader {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n.attrTitle {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 160%;\n  color: rgba(0, 0, 0, 0.55);\n}\n.required {\n  color: #e9033a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n.error {\n  margin-top: 4px;\n  color: #c20034;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n/*# sourceMappingURL=MfAttrEditor.module.css.map */"],"sourceRoot":""}]);
// Exports
export var attrBox = `src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrBox--QdXNY`;
export var attrHeader = `src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrHeader--YEoZh`;
export var attrTitle = `src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__attrTitle--tYxbC`;
export var required = `src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__required--R_Y6y`;
export var error = `src-components-MForm-components-MfAttrEditor-MfAttrEditor-module__error--KHMu4`;
export default ___CSS_LOADER_EXPORT___;
